/**
 * 新增規則表單用的線框圖示（10-06，取代 👤／🏢／👉 emoji）。
 *
 * emoji 在 Windows、Mac、手機上長得都不一樣，也和頁面其他線框 SVG（鈴鐺、垃圾桶、警告）風格不合。
 * 一律 24×24 viewBox、currentColor 線條，顏色跟著所在文字走；純裝飾，`aria-hidden`。
 */
function LineIcon({ size = 14, className, children }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

/** 寄件者清單的信箱列 */
export function PersonIcon(props) {
  return (
    <LineIcon {...props}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </LineIcon>
  );
}

/** 寄件者清單的網域列 */
export function BuildingIcon(props) {
  return (
    <LineIcon {...props}>
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
      <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
      <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
      <path d="M10 6h4" />
      <path d="M10 10h4" />
      <path d="M10 14h4" />
      <path d="M10 18h4" />
    </LineIcon>
  );
}

/** 選填群組展開時的「收起」（10-07，取代文字「收起」，和收起時的「＋」成對） */
export function MinusIcon(props) {
  return (
    <LineIcon {...props}>
      <path d="M5 12h14" />
    </LineIcon>
  );
}

/**
 * 下拉選單的箭頭（10-19 PO 檢視）：原生箭頭貼著右框、顏色各瀏覽器不同，
 * 改成自己畫，和旁邊的清除 ✕ 同色（都用 currentColor，外層給 var(--muted)）。
 */
export function ChevronDownIcon(props) {
  return (
    <LineIcon {...props}>
      <path d="m6 9 6 6 6-6" />
    </LineIcon>
  );
}

/** 清除／移除的 ✕：下拉、輸入框的清除鈕與清單每列的移除鈕共用（10-25 統一不帶圓圈），和 {@link ChevronDownIcon} 同樣線寬、同色 */
export function CloseIcon(props) {
  return (
    <LineIcon {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </LineIcon>
  );
}

